export const columns = [
  {
    label: "Line of Business",
    id: "lob",
    minWidth: 100,
    sortable: true,
  },
  {
    label: "Section Name",
    id: "name",
    minWidth: 150,
    sortable: true,
  },
  {
    label: "Resource Name",
    id: "resourceName",
    minWidth: 150,
    sortable: true,
  },
  {
    label: "Resource URL",
    id: "resourceUrl",
    minWidth: 200,
    sortable: true,
  },
  {
    label: "Action",
    id: "action",
    minWidth: 80,
    sortable: false,
  },
];
